import { render } from "./MailPrioritiesView.vue?vue&type=template&id=769f5897&scoped=true"
import script from "./MailPrioritiesView.vue?vue&type=script&lang=js"
export * from "./MailPrioritiesView.vue?vue&type=script&lang=js"

import "./MailPrioritiesView.vue?vue&type=style&index=0&id=769f5897&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769f5897"]])

export default __exports__